/* eslint-disable @typescript-eslint/ban-ts-comment */
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useField } from 'formik';

import useInput from '../hooks/useInput';
import { useMemo } from "react";

export interface FormikCheckboxProps {
  id?: string;
  name: string;
  value?: string;
  label?: string;
  classInput?: string;
  className?: string;
  disabled?: boolean;
  inputProps?: object;
}
export function FormikCheckbox(
  {
    id: defaultId,
    name,
    value,
    label,
    classInput,
    className,
    disabled = false,
    inputProps = {}
  }:FormikCheckboxProps
) {
  const [field, meta] = useField({
    name,
    value,
    type: 'checkbox'
  });
  const { id } = useInput(defaultId, label);
  const initialValue = useMemo(()=>{
    return String(meta.value) === 'true';
    // eslint-disable-next-line
  }, []);
  return (
    <div
      className={classNames(
        'form-check form-check-inline',
        className
      )}
    >
      <input
        id={id}
        // @ts-ignore
        name={name}
        className={classNames(
          'form-check-input',
          classInput
        )}
        disabled={disabled}
        {...inputProps}
        {...field}
        type="checkbox"
        defaultChecked={initialValue}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

FormikCheckbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  classInput: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inputProps: PropTypes.object
};

export default FormikCheckbox;
